module.exports = __webpack_public_path__ + "img/learn.e9c005f8.png";